



















import Vue from 'vue';
import { mapActions } from 'vuex';
import RadioToggleButtons from '@/components/common/form/RadioToggleButtons.vue';
import SingleSelect from '@/components/common/form/SingleSelect.vue';

interface LanguageSwitcherData {
    locale: string;
    langs: string[];
}

interface LanguageOption {
    value: string;
    label: any;
}

export default Vue.extend({
    name: 'LanguageSwitcher',
    components: { RadioToggleButtons, SingleSelect },
    data(): LanguageSwitcherData {
        return {
            locale: this.$store.state.locale || '',
            langs: this.$store.state.langs || [],
        };
    },
    computed: {
        availableLanguages(): LanguageOption[] {
            return this.langs.map((lang: string) => ({ value: lang, label: this.$t(lang) }));
        },
        languageLabels(): any[] {
            return this.langs.map((lang: string) => this.$t(lang));
        },
        currentLanguageLabel(): any {
            return this.$t(this.locale);
        },
        val(): LanguageOption {
            return { value: this.locale, label: this.$t(this.locale) };
        },
    },
    methods: {
        ...mapActions(['changeLocale']),
        handleLanguageChange(selectedLabel: string) {
            const selectedLang = this.langs.find((lang: string) => this.$t(lang) === selectedLabel);
            if (selectedLang) {
                this.changeLocale({ locale: selectedLang });
            }
        },
    },
});
